import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=0d5255e7&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"
import style0 from "./FormButton.vue?vue&type=style&index=0&id=0d5255e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_supports-color@7.2.0__css_4ebb8a9bdd1166ae2f68e8a453c2f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5255e7",
  null
  
)

export default component.exports